// Simple 1-hour localStorage cache for the Seed Fridge Inventory page's
// layout + shelfLife lookups. Layouts change infrequently; menus change more
// often but still not within a 1-hour test window. Skipping the two GraphQL
// round-trips shaves ~500ms off the page load for a repeat visit.
//
// Nothing here is authoritative — callers should still fall back to a live
// fetch if the cache is missing or the entry is stale.

const TTL_MS = 60 * 60 * 1000; // 1 hour
const KEY_PREFIX = 'seed-inventory-layout-cache';

function keyFor(locationId) {
  return `${KEY_PREFIX}:${locationId}`;
}

export function readCache(locationId) {
  if (!locationId) return null;
  try {
    const raw = window.localStorage.getItem(keyFor(locationId));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data.timestamp !== 'number') return null;
    if (Date.now() - data.timestamp > TTL_MS) return null;
    const { layoutName, slots, shelfLife } = data;
    if (!layoutName || !Array.isArray(slots) || typeof shelfLife !== 'object') {
      return null;
    }
    return { layoutName, slots, shelfLife };
  } catch (e) {
    return null;
  }
}

export function writeCache(locationId, { layoutName, slots, shelfLife }) {
  if (!locationId) return;
  try {
    window.localStorage.setItem(
      keyFor(locationId),
      JSON.stringify({
        timestamp: Date.now(),
        layoutName,
        slots,
        shelfLife,
      }),
    );
  } catch (e) {
    // quota exceeded, private browsing, etc. — cache miss is harmless.
  }
}

export function clearCache(locationId) {
  if (!locationId) return;
  try {
    window.localStorage.removeItem(keyFor(locationId));
  } catch (e) {
    // ignore
  }
}
